module.exports = __webpack_public_path__ + "img/mengHu1.28d471a9.png";